module.exports = __webpack_public_path__ + "static/media/image4.d6ed4007.png";